<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" class="elevation-1 mt-4">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <span> Clientes</span>
              <v-text-field
                dense
                placeholder="Buscar.."
                v-model="filtro"
                filled
                append-icon="mdi-filter"
                :disabled="loading"
                @click:append="filtrar()"
              ></v-text-field>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-plus
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.is_verificado`]="{ item }">
          <span> {{ item.is_verificado ? 'SI' : 'NO' }} </span>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <!-- <v-icon small class="mr-2 green--text" @click="verificarDoc(item)" title="Verificar Doc">
            mdi-check-decagram
          </v-icon> -->
          <!-- <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon> -->
        </template>
      </v-data-table>
    </template>

    <ClienteReg ref="clientereg" v-on:newregcliente="newregcliente" />
  </div>
</template>

<script>
  import ClienteReg from '@/views/recibos/clientes/registrar.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      filtro: '',
      headers: [
        { text: 'Razon Social', value: 'razon_social' },
        { text: 'Numero Documento', value: 'numero_documento' },
        { text: 'Complemento', value: 'complemento' },
        { text: 'Correo', value: 'email' },
        { text: 'Tipo Doc', value: 'tipo_documento.descripcion_SIN' },
        { text: 'Verificado', value: 'is_verificado' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { ClienteReg },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/clientes`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            let data = response.data.data;
            data.reverse();
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregcliente(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.razon_social = item.razon_social;
          e.numero_documento = item.numero_documento;
          e.numero_documento = item.numero_documento;
          e.complemento = item.complemento;
          e.email = item.email;
          e.tipo_documento_id = item.tipo_documento_id;
          e.is_verificado = item.is_verificado;
        } else {
          this.initialize();
        }
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.clientereg.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      filtrar() {
        if (this.loading) return;
        this.desserts = [];

        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/clientes?numero_documento=${this.filtro}&razon_social=${this.filtro}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            let data = response.data.data;
            vue.desserts = data;
            vue.loading = false;
            //vue.$root.$notify.show(`Funcion no implementada`, { color: 'red', x: 'left' });
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      verificarDoc() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Verificar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Verificacion de Documento',
          body: '<br> <b>NOTA:</b> continue.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.verificarDoc2(dialog);
          })
          .catch(function() {});
      },
      verificarDoc2(dialog) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sincronizar/catalogo`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          //data: {},
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            dialog.close();
            vue.$root.$notify.show(response.data, { color: 'success' });
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
    },
  };
</script>
